import { Nav, Tab } from "react-bootstrap";
import { IInstructionDetails } from "../../../api/Instruction";
import { DocumentsGrid } from "../../../leap-components/Documents/DocumentsGrid";
import EpaCard from "../../../leap-components/EpaCard";

interface SubTabsProps {
  className?: string;
  activeKey: string;
  instruction: IInstructionDetails;
}

interface InstructionProps {
  instruction: IInstructionDetails;
}

const SubTabs = ({ className, activeKey, instruction }: SubTabsProps) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="documents">Documents</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="documents">
          <DocumentsGrid
            regardingObjectId={instruction.epainitiatedcorrespondenceid}
          />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
);

const RelatedComplianceRecords = ({ instruction }: InstructionProps) => {
  var bodyElements = (
    <SubTabs activeKey="documents" instruction={instruction} />
  );

  return (
    <EpaCard title={"Related Compliance Records"} content={bodyElements} />
  );
};

export default RelatedComplianceRecords;
